<template>
  <div class="box font-s-14">
    <div class="height-100">
      <div class="topview">
        <div class="banner font-c-w">
          <!-- 未登录 -->
          <div v-if="!name" class="flex  a-i-c">
            <div style="display: flex; align-items: center; text-align: center;">
              <div class="bottom-img"></div>
              <div @click="goLogin" class="t-a-c" style="margin-left: 1rem;">去登录</div>
            </div>
          </div>
          <!-- 已登录（包括预览模式） -->
          <div v-else class="flex  a-i-c" style="width:100%;justify-content:space-around">
            <div style="display: flex; align-items: center; text-align: center;width: 85%;">
              <div v-if="userInfo" class="img-tx"></div>
              <div style="margin-left: 1rem; text-align: left;font-size: 1.28rem;color: #323747">{{ name }}
              </div>
            </div>
            <div style="width:12%;">
              <!-- <van-icon class="m-l-10" name="setting-o" size="25" @click="go('/Personal')" /> -->
              <!-- 设置 -->
              <!-- <span style="font-family: PingFangSC-Medium;color:  #FFFFFF;font-size: 1rem;margin-right: 2rem;" @click="go('/Personal')">设置</span> -->
              <!-- <van-icon color="#323747" name="setting-o" size="1.5rem" @click="go('/Personal')" style="margin-right:1rem;" /> -->
              <i @click="go('/Personal')">
                <svg t="1703770144240" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="18018" width="30" height="30">
                  <path
                    d="M512 697.6c102.4 0 182.4-83.2 182.4-185.6 0-102.4-83.2-185.6-182.4-185.6-102.4 0-182.4 83.2-182.4 185.6C329.6 614.4 412.8 697.6 512 697.6L512 697.6zM512 646.4c-73.6 0-134.4-60.8-134.4-134.4 0-73.6 60.8-134.4 134.4-134.4 73.6 0 134.4 60.8 134.4 134.4C646.4 585.6 585.6 646.4 512 646.4L512 646.4z"
                    p-id="18019"></path>
                  <path
                    d="M249.015232 843.178592c35.2 28.8 73.6 51.2 112 67.2 41.6-38.4 96-60.8 150.4-60.8 57.6 0 108.8 22.4 150.4 60.8 41.6-16 80-38.4 112-67.2-12.8-54.4-3.2-112 22.4-163.2 28.8-48 73.6-86.4 128-102.4 3.2-22.4 6.4-44.8 6.4-67.2 0-22.4-3.2-44.8-6.4-67.2-54.4-16-99.2-54.4-128-102.4-28.8-48-35.2-108.8-22.4-163.2-35.2-28.8-73.6-51.2-112-67.2-41.6 38.4-92.8 60.8-150.4 60.8-54.4 0-108.8-22.4-150.4-60.8-41.6 16-80 38.4-112 67.2 12.8 54.4 3.2 112-22.4 163.2-28.8 48-73.6 86.4-128 102.4-3.2 22.4-6.4 44.8-6.4 67.2 0 22.4 3.2 44.8 6.4 67.2 54.4 16 99.2 54.4 128 102.4C252.215232 731.178592 261.815232 788.778592 249.015232 843.178592M361.015232 958.378592c-54.4-19.2-105.6-48-150.4-89.6-6.4-6.4-9.6-16-6.4-22.4 16-48 9.6-99.2-16-140.8-25.6-44.8-64-73.6-112-83.2-9.6-3.2-16-9.6-16-19.2-6.4-28.8-9.6-60.8-9.6-89.6 0-28.8 3.2-57.6 9.6-89.6 3.2-9.6 9.6-16 16-19.2 48-12.8 89.6-41.6 112-83.2 25.6-44.8 28.8-92.8 16-140.8-3.2-9.6 0-19.2 6.4-22.4 44.8-38.4 96-67.2 150.4-89.6 9.6-3.2 16 0 22.4 6.4 35.2 35.2 80 57.6 128 57.6 48 0 96-19.2 128-57.6 6.4-6.4 16-9.6 22.4-6.4 54.4 19.2 105.6 48 150.4 89.6 6.4 6.4 9.6 16 6.4 22.4-16 48-9.6 99.2 16 140.8 25.6 44.8 64 73.6 112 83.2 9.6 3.2 16 9.6 16 19.2 6.4 28.8 9.6 60.8 9.6 89.6 0 28.8-3.2 57.6-9.6 89.6-3.2 9.6-9.6 16-16 19.2-48 12.8-89.6 41.6-112 83.2-25.6 44.8-28.8 92.8-16 140.8 3.2 9.6 0 19.2-6.4 22.4-44.8 38.4-96 67.2-150.4 89.6-9.6 3.2-16 0-22.4-6.4-35.2-35.2-80-57.6-128-57.6-48 0-96 19.2-128 57.6-3.2 3.2-9.6 6.4-16 6.4C364.215232 958.378592 361.015232 958.378592 361.015232 958.378592z"
                    p-id="18020"></path>
                </svg>
              </i>
              <!-- 扫一扫 -->
              <!-- <span style="font-family: PingFangSC-Medium;color:  #FFFFFF;font-size: 1rem;margin-right:1rem;" @click="wxUrlSign">扫一扫</span> -->
              <!-- <van-icon color="#323747" name="scan" size="1.5rem" @click="wxUrlSign" style="margin-right:1rem;" /> -->
              <!-- <i @click="wxUrlSign" style="margin-right:0.8rem;display: inline-block;">
                <svg t="1703680518398" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8240" width="36" height="36">
                  <path d="M213.333333 426.666667V213.333333h213.333334v85.333334H298.666667v128H213.333333z m0 170.666666h85.333334v128h128v85.333334H213.333333v-213.333334z m597.333334-170.666666h-85.333334V298.666667h-128V213.333333h213.333334v213.333334z m0 170.666666v213.333334h-213.333334v-85.333334h128v-128h85.333334z m0-128v85.333334H213.333333v-85.333334h597.333334z" fill="#444444" p-id="8241"></path>
                </svg>
              </i> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 我的订单 -->
      <div
        style="border-radius: 1rem; background-color:#fff; margin-left: 0.8rem; margin-right: 0.8rem; margin-top: -4rem; flex-direction: column; overflow: hidden;padding: 0.2rem;">
        <div style="margin: 0.8rem; font-size: 1rem; display: flex; justify-content: space-between;">
          <div style="color: #303030; font-weight: 600;font-size: 1rem;">
            我的订单
          </div>
          <div style="font-size: 1rem; color: rgb(148 146 146)" @click="go('/AllOrder')">
            全部订单
            <van-icon name="arrow" color="#949292" style="margin-left:-5px" />
          </div>
        </div>
        <div style="display: flex; padding-bottom: 0.8rem; padding-top: 0.4rem;">
          <div class="t-a-c flex-1" style="display: flex;flex-direction: column; font-size: 1rem;"
            @click="go('/AllOrder', 'active', 1)">
            <!-- <div class="iconfont icon-iconfont0090 mb-10 icon2"></div> -->
            <!-- <van-icon size="1.8rem" name="todo-list-o" /> -->
            <!-- <van-icon name="credit-pay" size="1.8rem" color="#303030" /> -->
            <i>
              <svg t="1703677045453" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="20636" width="32" height="32">
                <path
                  d="M903.1 665.6H583.2c-57.6-0.2-104.6-47.1-104.7-104.7v-97.3c0.2-57.6 47.1-104.6 104.7-104.7h320v41.4h-320c-34.8 0.1-63.3 28.6-63.4 63.4v97.2c0.1 34.8 28.6 63.3 63.4 63.4h319.9v41.3z"
                  fill="#231815" p-id="20637"></path>
                <path
                  d="M553.1 512.2c0 16.6 13.5 30.1 30.1 30.1s30.1-13.5 30.1-30.1-13.5-30.1-30.1-30.1c-16.7 0-30.1 13.5-30.1 30.1z m0 0"
                  fill="#231815" p-id="20638"></path>
                <path
                  d="M867 893.5H157.7c-34.2 0-62-27.8-62-62V192.9c0-34.2 27.8-62 62-62H867c34.2 0 62 27.8 62 62v638.6c0 34.2-27.8 62-62 62zM157.7 172.3c-11.4 0-20.7 9.3-20.7 20.7v638.6c0 11.4 9.3 20.7 20.7 20.7H867c11.4 0 20.7-9.3 20.7-20.7V192.9c0-11.4-9.3-20.7-20.7-20.7H157.7z"
                  fill="#231815" p-id="20639"></path>
              </svg>
            </i>
            <p style=" margin-top: 0.2rem;" class="myOrderP">待付款</p>
          </div>
          <div class="t-a-c flex-1" style="display: flex;flex-direction: column; font-size: 1rem;"
            @click="go('/AllOrder', 'active', 2)">
            <!-- <div class="iconfont icon-baoguo mb-10 icon2"></div> -->
            <i>
              <svg t="1703676980055" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="19288" width="32" height="32">
                <path
                  d="M114.133333 490.666667l-14.656 22.378666a21.333333 21.333333 0 0 0-3.477333 11.690667V725.333333a21.333333 21.333333 0 0 0 21.333333 21.333334h42.794667v42.666666H117.333333a64 64 0 0 1-64-64v-200.597333a64 64 0 0 1 10.453334-35.072l134.101333-204.736A64 64 0 0 1 251.434667 256h144.746666A149.376 149.376 0 0 1 544 128h277.333333a149.333333 149.333333 0 0 1 149.333334 149.333333v362.666667a149.333333 149.333333 0 0 1-149.333334 149.333333v-42.666666a106.666667 106.666667 0 0 0 106.666667-106.666667V277.333333a106.666667 106.666667 0 0 0-106.666667-106.666666h-277.333333a106.666667 106.666667 0 0 0-106.666667 106.666666v469.333334h231.36v42.666666h-338.773333v-42.666666H394.666667V298.666667h-64v170.666666a64 64 0 0 1-64 64h-170.666667v-42.666666h18.133333z m0 0h152.533334a21.333333 21.333333 0 0 0 21.333333-21.333334v-170.666666h-36.565333a21.333333 21.333333 0 0 0-17.856 9.642666L114.133333 490.666667z"
                  fill="#222222" p-id="19289"></path>
                <path
                  d="M245.333333 896a106.666667 106.666667 0 1 1 0-213.333333 106.666667 106.666667 0 0 1 0 213.333333z m0-42.666667a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM757.333333 896a106.666667 106.666667 0 1 1 0-213.333333 106.666667 106.666667 0 0 1 0 213.333333z m0-42.666667a64 64 0 1 0 0-128 64 64 0 0 0 0 128z"
                  fill="#222222" p-id="19290"></path>
              </svg>
            </i>
            <p style="margin-top: 0.2rem;" class="myOrderP">待收货</p>
          </div>
          <!-- <div class="t-a-c flex-1" style="font-size: 1rem;" @click="go('/AllOrder', 'active', 3)">
            <div class="iconfont icon-baoguo mb-10 icon2"></div>
            待收获
          </div> -->
          <div class="t-a-c flex-1" style="font-size: 1rem;margin-right: 0.5rem;" @click="go('/AllOrder', 'active', 3)">
            <!-- <div class="iconfont icon-daifahuo mb-10 icon2"></div> -->
            <!-- <van-icon size="1.8rem" name="balance-list-o" /> -->
            <i>
              <svg t="1703677078546" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="22555" width="32" height="32">
                <path
                  d="M853.333333 768.064A426.112 426.112 0 0 1 512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667a21.333333 21.333333 0 0 1-42.666667 0c0-212.074667-171.925333-384-384-384S128 299.925333 128 512s171.925333 384 384 384a383.573333 383.573333 0 0 0 319.36-170.666667h-84.757333A21.248 21.248 0 0 1 725.333333 704c0-11.776 9.664-21.333333 21.269334-21.333333h128.128c5.866667 0 11.178667 2.346667 15.018666 6.186666l0.021334 0.106667c3.84 3.882667 6.229333 9.173333 6.229333 14.976v128.128c0 11.733333-9.472 21.269333-21.333333 21.269333-11.776 0-21.333333-9.664-21.333334-21.269333v-64zM558.378667 426.666667h81.493333c11.84 0 21.461333 9.472 21.461333 21.333333 0 11.776-9.6 21.333333-21.482666 21.333333H533.333333v85.333334h106.517334c11.861333 0 21.482667 9.472 21.482666 21.333333 0 11.776-9.6 21.333333-21.482666 21.333333H533.333333v127.850667c0 11.861333-9.472 21.482667-21.333333 21.482667-11.776 0-21.333333-9.578667-21.333333-21.482667V597.333333h-106.517334A21.354667 21.354667 0 0 1 362.666667 576c0-11.776 9.6-21.333333 21.482666-21.333333H490.666667v-85.333334h-106.517334A21.354667 21.354667 0 0 1 362.666667 448c0-11.776 9.6-21.333333 21.482666-21.333333h81.472l-97.813333-114.133334a21.333333 21.333333 0 0 1 32.384-27.733333L512 415.189333l111.786667-130.432a21.333333 21.333333 0 1 1 32.426666 27.776L558.357333 426.666667z"
                  fill="#3D3D3D" p-id="22556"></path>
              </svg>
            </i>
            <p style="margin-top: 0.2rem;" class="myOrderP">已完成</p>
          </div>
          <!-- <van-badge :content="total" class="flex-1">
              <div class="t-a-c">
                <div class="iconfont icon-pingjia mb-10 icon2"></div>
                待评价
              </div>
            </van-badge> -->
        </div>
      </div>
      <!-- 蛋糕门店兑换 -->
      <!-- <div
        style="border-radius: 1rem; background-color:#fff; margin-left: 0.8rem; margin-right: 0.8rem; margin-top: 0.8rem; flex-direction: column; overflow: hidden;padding: 0.2rem;">
        <div style=" margin: 0.8rem; flex-direction: column; overflow: hidden;">
          <div style="display: flex; flex-direction: row; align-items: center;">
           
            <span style="color: #303030; font-size: 1rem;font-weight: 600;">蛋糕门店兑服务</span>
          </div>
  
          <div style="display: flex; padding-bottom: 0.2rem; padding-top: 1.4rem;">
           
            <div class="t-a-c flex-1" style="display: flex;flex-direction: column; font-size: 1rem;" @click="go('/')">
              <i>
                <svg t="1703743478243" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="13892" width="32" height="32">
                  <path
                    d="M767.4 878.6H173.7c-60 0-108.8-48.8-108.8-108.8V324.5c0-60 48.8-108.8 108.8-108.8h96.7c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96.7c-33.5 0-60.8 27.3-60.8 60.8v445.3c0 33.5 27.3 60.8 60.8 60.8h593.7c80.3 0 145.6-65.3 145.6-145.6 0-13.3 10.7-24 24-24s24 10.7 24 24c0 106.8-86.8 193.6-193.6 193.6z m84.1-219h-593c-13.3 0-24-10.7-24-24s10.7-24 24-24h593c13.8 0 25.2-1.9 34.2-5.6h0.1c24.2-10.1 27.3-34.9 27.3-55.3V324.5c0-33.5-27.3-60.8-60.8-60.8h-88.6c-13.3 0-24-10.7-24-24s10.7-24 24-24h88.6c60 0 108.8 48.8 108.8 108.8v226.1c0 23-4.1 42.7-12.3 58.7-9.6 18.8-24.6 32.6-44.5 40.9h-0.1c-14.8 6.2-32.6 9.4-52.7 9.4z"
                    fill="#333333" p-id="13893"></path>
                  <path
                    d="M385.1 534.5c-9.8 0-19.4-3.5-27.9-10.3-10.3-8.3-12-23.4-3.7-33.7 7.7-9.7 21.4-11.8 31.6-5.3 2.7-2.7 6.2-7.7 7.8-11.2 0.2-0.5 0.5-1 0.7-1.4l106-190.8c4.2-7.6 12.3-12.3 21-12.3s16.7 4.7 21 12.3l106 190.8c0.2 0.3 0.2 0.4 0.4 0.7 2.3 4.3 6.1 9.2 8.8 11.5 10.4-6.2 24-3.6 31.4 6.3 8 10.6 5.8 25.6-4.8 33.6-10.8 8.1-23.5 11-35.9 8.1-24.2-5.6-38.8-31.1-42-37.1l-84.9-152.8-84.7 152.5c-3.4 7-17.4 32.5-41.5 38.1-3 0.7-6.1 1-9.3 1z"
                    fill="#333333" p-id="13894"></path>
                  <path
                    d="M612.1 355c-62.9 0-114-51.1-114-114s51.1-114 114-114 114 51.1 114 114c0 62.8-51.2 114-114 114z m0-180c-36.4 0-66 29.6-66 66s29.6 66 66 66 66-29.6 66-66-29.6-66-66-66z"
                    fill="#333333" p-id="13895"></path>
                  <path
                    d="M423.5 355c-62.9 0-114-51.1-114-114s51.1-114 114-114 114 51.1 114 114-51.1 114-114 114z m0-180c-36.4 0-66 29.6-66 66s29.6 66 66 66 66-29.6 66-66-29.6-66-66-66z"
                    fill="#333333" p-id="13896"></path>
                </svg>
              </i>
              <p style="margin-top: 0.2rem;" class="myOrderP">卡列表</p>
            </div>
            <div class="t-a-c flex-1" style="font-size: 1rem;margin-right: 0.2rem;" @click="showToast">
              <i style="margin-left:0.1rem">
                <svg t="1703743447209" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="12758" width="32" height="32">
                  <path
                    d="M512 877.714286H73.142857a18.285714 18.285714 0 0 1-18.285714-18.285715v-475.428571a17.92 17.92 0 0 1 6.948571-14.262857l365.714286-292.571429a17.554286 17.554286 0 0 1 22.674286 0l365.714285 292.571429a18.285714 18.285714 0 1 1-22.674285 28.525714L438.857143 114.834286l-347.428572 277.942857V841.142857H512a18.285714 18.285714 0 0 1 0 36.571429z"
                    fill="#111111" p-id="12759"></path>
                  <path
                    d="M804.571429 420.571429a18.285714 18.285714 0 0 1-18.285715-18.285715v-18.285714a18.285714 18.285714 0 0 1 36.571429 0v18.285714a18.285714 18.285714 0 0 1-18.285714 18.285715zM699.977143 668.16a19.017143 19.017143 0 0 1-11.702857-4.022857 18.651429 18.651429 0 0 1-2.56-25.965714L760.685714 548.571429a18.285714 18.285714 0 0 1 25.6-2.56 19.017143 19.017143 0 0 1 2.56 25.965714l-74.971428 89.6a17.92 17.92 0 0 1-13.897143 6.582857zM909.165714 668.16a17.92 17.92 0 0 1-13.897143-6.582857l-74.971428-89.6a19.017143 19.017143 0 0 1 2.56-25.965714 18.285714 18.285714 0 0 1 25.6 2.56l74.971428 89.6a18.651429 18.651429 0 0 1-2.56 25.965714 19.017143 19.017143 0 0 1-11.702857 4.022857z"
                    fill="#111111" p-id="12760"></path>
                  <path
                    d="M804.571429 608.548571a48.274286 48.274286 0 1 1 48.274285-48.274285A48.64 48.64 0 0 1 804.571429 608.548571zM804.571429 548.571429a11.702857 11.702857 0 0 0-11.702858 11.702857 11.702857 11.702857 0 0 0 23.405715 0A11.702857 11.702857 0 0 0 804.571429 548.571429zM969.142857 877.714286h-329.142857a18.285714 18.285714 0 0 1-18.285714-18.285715v-209.554285a18.285714 18.285714 0 0 1 18.285714-18.285715h329.142857a18.285714 18.285714 0 0 1 18.285714 18.285715v209.554285a18.285714 18.285714 0 0 1-18.285714 18.285715zM658.285714 841.142857h292.571429v-172.982857h-292.571429zM658.285714 548.571429H201.142857a18.285714 18.285714 0 0 1 0-36.571429H658.285714a18.285714 18.285714 0 0 1 0 36.571429zM512 694.857143H201.142857a18.285714 18.285714 0 0 1 0-36.571429H512a18.285714 18.285714 0 0 1 0 36.571429z"
                    fill="#111111" p-id="12761"></path>
                </svg>
              </i>
              <p style="margin-top: 0.2rem;" class="myOrderP">支持门店</p>
            </div>
          </div>
        </div>
      </div>-->
      <!-- 其他服务 -->
      <div
        style="border-radius: 1rem; background-color:#fff; margin-left: 0.8rem; margin-right: 0.8rem; margin-top: 0.8rem; margin: 0.8rem; flex-direction: column; overflow: hidden;padding-bottom: 1rem;padding: 0.2rem;">
        <div style="display: flex; padding-bottom: 0.5rem; padding-top: 1.4rem;">
          <div class="t-a-c flex-1" style="display: flex;flex-direction: column; font-size: 1rem;" @click="callService">
            <i>
              <svg t="1703743036678" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="4271" width="32" height="32">
                <path
                  d="M516.667511 807.863307c5.004179 0 10.095748-0.308016 15.221701-0.916884 49.157857-5.899573 90.900417-40.259787 106.306927-87.609664 1.163296-3.541463-0.515747-7.336502-3.906784-8.892339-3.352356-1.561567-7.409566-0.212029-9.306369 2.965546-0.179079 0.302285-19.710133 31.848813-95.745574 42.117909-11.382251 1.527184-22.457919 2.328025-32.956236 2.328025-53.270939-0.034383-77.00963-20.112702-77.22739-20.297512-2.680452-2.383897-6.772045-2.445501-9.519831-0.123206-2.775006 2.322294-3.413959 6.358015-1.521454 9.446767C431.202495 784.477044 472.816118 807.863307 516.667511 807.863307L516.667511 807.863307zM516.667511 807.863307M925.504492 336.633827c-0.670471 0-1.280772 0.123206-1.918292 0.123206C879.03425 143.879099 708.803342 0 504.703612 0c-209.712777 0-383.850469 151.824469-422.446972 352.685021C44.728879 359.438442 16.165088 392.423331 16.165088 432.3135l0 159.653796c0 44.746787 35.883101 81.032457 80.188637 81.032457 24.992242 0 47.051889-11.802012 61.726326-29.927655 35.457609 93.781437 107.642139 169.397117 198.995267 209.293016 0.21776-0.475633 1.946945-3.83945 4.028557-6.519902 1.438361-1.858122 3.050071-3.379576 4.432559-3.379576 1.432631 0 2.747786 0.520045 3.872401 1.313722-21.142764-15.741746-97.51344-96.656727-114.056026-209.572379-7.257707-49.699391 29.967769-98.487629 73.322038-106.557638 69.600064-12.959577 138.836239-27.722836 208.436303-40.437434 44.243933-8.070009 74.479604-32.340205 92.969135-72.750419 4.332275-9.446767 10.588573-28.546599 13.459565-56.091789 0.760727-4.095891 4.118813-7.240515 8.422436-7.240515 2.870992 0 5.310762 1.465581 6.928202 3.575846l1.919725-1.191949c27.432012 39.827133 81.833297 128.012715 89.645432 220.999042 8.971133 106.311225 3.966954 179.124679-77.406468 253.615744-0.095986 0.094554-0.219192 0.212029-0.336668 0.308016-1.130346 1.219169-1.802249 2.807956-1.802249 4.554333 0 2.289344 1.220601 4.24775 2.988468 5.439699 0.671904 0.275065 1.343808 0.643251 2.015711 0.918316 0.547265 0.123206 1.068742 0.302285 1.61744 0.302285 0.552995 0 1.04009-0.179079 1.527184-0.302285 1.158998-0.610301 2.254961-1.315155 3.385306-1.925456 82.293172-45.335598 145.423475-121.045832 174.596134-212.108136 11.809175 17.543995 30.298706 30.16977 51.776705 34.573676C874.366739 816.570836 734.623645 914.634406 561.493092 929.519439c-10.375111-25.73721-35.916051-44.014712-65.91104-44.014712-39.173853 0-70.938141 31.026483-70.938141 69.264828 0 38.239778 31.758557 69.230445 70.938141 69.230445 31.585209 0 58.037302-20.291781 67.220464-48.172207 200.406408-16.290443 361.057315-135.410819 394.595199-320.495243 29.626803-12.38366 50.432898-41.450304 50.432898-75.380729L1007.830614 418.406954C1007.830614 373.256165 970.969026 336.633827 925.504492 336.633827L925.504492 336.633827zM851.573585 383.038168C799.305488 241.448412 663.860285 140.301821 504.524533 140.301821c-158.669579 0-293.627687 100.289878-346.382879 240.96275-2.624579-3.211958-5.703303-5.959744-8.724721-8.741912C179.282985 201.099801 326.816725 70.76336 504.703612 70.76336c177.035904 0 324.10977 129.054237 354.955741 299.286578C856.610715 374.145829 853.801326 378.420799 851.573585 383.038168L851.573585 383.038168zM851.573585 383.038168M357.086779 852.365114c-0.005731 0-0.005731 0-0.011461 0C357.042368 852.436745 357.042368 852.448206 357.086779 852.365114L357.086779 852.365114zM357.086779 852.365114"
                  fill="#ea2528" p-id="4272"></path>
              </svg>
            </i>
            <p style=" margin-top: 0.2rem;" class="myOrderP">在线客服</p>
          </div>
          <div class="t-a-c flex-1" style="display: flex;flex-direction: column; font-size: 1rem;" @click="callPhone()">
            <i>
              <svg t="1703743238389" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="5584" width="32" height="32">
                <path
                  d="M690.67561984 185.49293511c-132.26543331 6.66205411-243.59535616 81.83089038-227.4148955 213.14282155 21.88347733 84.68447459 72.03293867 105.30584235 99.9114331 123.7019136 8.56352085 20.93551161-29.49903246 94.20149646-29.49903246 94.20149646s59.94741305 13.31995648 138.92195214-63.75449941c33.30196594 5.7085531 241.68835299 0.95350101 249.30390813-178.88735574-0.35427669-12.20730766 2.85496775-171.27733589-231.22336541-188.40437646zM566.02712519 417.66980153c-26.27318101 0-47.57542343-21.30085888-47.57542229-47.57542343 0-26.27318101 21.30085888-47.57542343 47.57542229-47.57542343s47.57542343 21.30085888 47.57542343 47.57542343c-0.00138354 26.27456455-21.30224242 47.57542343-47.57542343 47.57542343z m125.60199566 0c-26.27318101 0-47.57542343-21.30085888-47.57542229-47.57542343 0-26.27318101 21.30085888-47.57542343 47.57542229-47.57542343s47.57542343 21.30085888 47.57542344 47.57542343-21.30224242 47.57542343-47.57542344 47.57542343z m123.7019136 0c-26.27318101 0-47.57542343-21.30085888-47.57542343-47.57542343 0-26.27318101 21.30085888-47.57542343 47.57542343-47.57542343 26.27318101 0 47.57542343 21.30085888 47.5754223 47.57542343-0.00138354 26.27456455-21.30224242 47.57542343-47.5754223 47.57542343z"
                  fill="#ea2528" p-id="5585"></path>
                <path
                  d="M335.89426631 296.0340389c-5.84555747 34.1641307-47.11873877 36.94436807-62.93800277 123.53584583 1.90146674 121.80044573 98.95793209 224.56684771 198.86936519 257.86881252 107.52145294 28.54553031 127.3609216-48.29919801 171.79075925-46.2219776 45.39441038 2.12980963 127.94354005 105.21588963 127.08691172 129.96402289-7.99335765 53.92886898-90.95350386 123.11375872-198.96070258 97.99335936C386.19180487 833.48353934 127.37640903 567.05120483 105.48739755 374.8452773 90.26043904 238.77691051 154.01493731 179.77746205 210.09714176 163.34651847c41.51674653 0.25186873 128.51370325 95.41793792 125.79712455 132.68752043z"
                  fill="#ea2528" p-id="5586"></path>
              </svg>
            </i>
            <p style="margin-top: 0.2rem;" class="myOrderP">联系我们</p>
          </div>
          <div class="t-a-c flex-1" style="font-size: 1rem;margin-right: 0.2rem;" @click="go('/AddressView')">
            <i style="margin-left:0.1rem">
              <svg t="1703743279587" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="6658" width="32" height="32">
                <path
                  d="M512.005117 0.346901c-282.287201 0-434.613492 213.591633-434.613492 396.730697 0 190.322673 196.84625 402.487817 429.855118 504.555447l4.758374 2.100848 4.758374-2.100848c232.997612-102.066607 429.844885-314.251194 429.844885-504.555447C946.607352 213.93751 794.292318 0.346901 512.005117 0.346901zM512.00307 526.686491c-108.035552 0-195.61419-87.579661-195.61419-195.61419S403.967518 135.458111 512.00307 135.458111c108.033505 0 195.61419 87.579661 195.61419 195.61419S620.037599 526.686491 512.00307 526.686491z"
                  fill="#ea2528" p-id="6659"></path>
                <path d="M259.848143 984.530057a246.409 38.232 0 1 0 504.303714 0 246.409 38.232 0 1 0-504.303714 0Z"
                  fill="#ea2528" p-id="6660"></path>
              </svg>
            </i>
            <p style="margin-top: 0.2rem;" class="myOrderP">收货地址</p>
          </div>
          <div 
            class="t-a-c flex-1" 
            style="display: flex;flex-direction: column; font-size: 1rem;" 
            :style="{ opacity: isPreviewMode ? 0.5 : 1, cursor: isPreviewMode ? 'not-allowed' : 'pointer' }"
            @click="handleSetPassword">
            <i>
              <svg t="1703679444082" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="44502" width="32" height="32">
                <path
                  d="M512 63.2L160.8 226.4v244.8c0 226.4 149.6 437.6 351.2 489.6 201.6-51.2 351.2-263.2 351.2-489.6V226.4L512 63.2z m-8 574.4l-45.6 45.6-45.6-45.6-90.4-90.4 45.6-45.6L458.4 592l204-204 45.6 45.6L504 637.6z"
                  p-id="44503" fill="#ea2528"></path>
              </svg>
            </i>
            <p style=" margin-top: 0.2rem;" class="myOrderP">支付密码</p>
          </div>
        </div>
      </div>
      <!-- <div style=" margin: 0.8rem; flex-direction: column; overflow: hidden;padding-bottom: 5rem;">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <div style="height: 1rem;width: 0.2rem;border-radius: 0.7rem;background-image: linear-gradient(180deg, #FF685B 0%, #D23B2E 100%);">
          </div>
          <span style="color: #333; font-size: 1rem;font-weight: 600;margin-left: 0.5rem;">其他服务</span>
        </div>
        <div style="margin-top: 1rem;  border-radius: 0.3rem; background-color: #fff;display: flex;flex-direction: column;padding: 0 0.5rem;">
          <div class="item" @click="showToast">
            <div class="flex">
              <van-image style="height: 1rem; width: 1rem;" :src="require('../../assets/images/my_icon1.svg')"></van-image>
              <div style="margin-left: 0.5rem;"> 在线客服 </div>
            </div>
            <van-icon name="arrow" color="#999" />
          </div>
          <div style="height: 1px; width: 100%;background-color: #EEE;"></div>
          <div class="item" @click="callPhone()">
            <div class="flex">
              <van-image style="height: 1rem; width: 1rem;" :src="require('../../assets/images/my_icon2.svg')"></van-image>
              <div style="margin-left: 0.5rem;"> 联系我们 </div>
            </div>
            <van-icon name="arrow" color="#999" />
          </div>
          <div style="height: 1px; width: 100%;background-color: #EEE;"></div>
          <div class="item" @click="go('/AddressView')">
            <div class="flex">
              <van-image style="height: 1rem; width: 1rem;" :src="require('../../assets/images/my_icon3.svg')"></van-image>
              <div style="margin-left: 0.5rem;"> 收货地址 </div>
            </div>
            <van-icon name="arrow" color="#999" />
          </div>
          <div style="height: 1px; width: 100%;background-color: #EEE;"></div>
          <div class="item" @click="setPassword">
            <div class="flex">
              <van-image style="height: 1rem; width: 1rem;" :src="require('../../assets/images/my_icon4.svg')"></van-image>
              <div style="margin-left: 0.5rem;"> 支付密码 </div>
            </div>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
      </div> -->
      <!-- 分类 -->

      <!-- <div class="flex jcsb p-10 font-s-16 border-b" @click="go('/Collection')">
        <div class="flex a-i-c">
          <i class="iconfont icon-shoucang icon1"></i> 收藏商品
        </div>
        <div><i class="iconfont icon-youjiantou"></i></div>
      </div> -->

      <!-- <div class="flex jcsb p-10 font-s-16 border-b" @click="go('/History')">
        <div class="flex a-i-c">
          <i class="iconfont icon-liulan icon1"></i>
          最近浏览
        </div>
        <div><i class="iconfont icon-youjiantou"></i></div>
      </div> -->
    </div>
    <!-- 底部 -->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import FootNav from "../../components/footnav/FootNav.vue";
import wx from "weixin-js-sdk";
import { openCustomerService } from "@/utils/customerService";

export default {

  props: {},
  data() {
    return {
      fromCard: true,
      currentTime: '',
      userInfo: {
        avatar: "../../assets/images/header.png"
      },
      total: "23",
    };
  },


  components: { FootNav },
  methods: {
    wxUrlSign() {
      // console.log('window.entryUrl', window.entryUrl)
      //判断是否时安卓系统获取路径
      let signLink = /(Android)/i.test(navigator.userAgent) ? location.href : window.entryUrl;
      //刷新后路径变化使用当前路径
      if (encodeURIComponent(signLink) == 'undefined') signLink = location.href
      this.$api
        .wxUrlSign(signLink)
        .then((res) => {
          if (res.code == 0) {
            wx.config(
              {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数
                appId: res.data.appId,
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名
                jsApiList: ['scanQRCode'],    // 必填，需要使用的JS接口列表
              });
            wx.error((res) => {
              console.log("获取失败");
            });
            wx.ready(() => {
              wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: (res) => {
                  this.boundBenefitCardByQR(res.resultStr)
                },
                cancel: () => {
                  //扫码失败
                },
              });
            });

          }

        })
        .catch((err) => {
          console.log(err);
        });
    },
    // scan
    boundBenefitCardByQR(result) {
      this.$api
        .boundBenefitCardByQR(result).then((res) => {
          if (res.code == 0) {
            this.$router.back();
          } else {
            this.$Toast(res.msg)
          }
        })
        .catch((err) => {
        });
    },
    // 拨打电话
    callPhone() {
      window.location.href = "tel:400-001-6621";
    },
    callService: openCustomerService,
    setPassword() {
      this.$router.push("/SetPassWord");
    },
    handleSetPassword() {
      if (this.isPreviewMode) {
        this.$Toast("预览用户无需设置");
        return;
      }
      this.setPassword();
    },
    // 前去登陆
    goLogin() {
      this.$router.push("/Login");
    },
    showToast() {
      this.$Toast("敬请期待！");
    },
    // 跳转路由
    go(val, key, value) {
      if (val === "/AddressView") {
        localStorage.removeItem("toOder");
      }
      // if (this.name) {
      this.$publicJs.go(val, key, value);
      // } else {
      //   this.$Toast("未登录");
      // }
    },
    // 评价的角标
    // 未评价接口
    no() {
      this.$api
        .tobeEvaluated()
        .then((res) => {
          this.total = res.data.count;
          this.total === 0 ? (this.total = null) : this.total;
        })
        .catch();
    },


    // 生成随机字符串
    generateRandomString(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // this.userInfo ? this.no() : "";
    // this.currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳并存储在currentTime变量中
    // wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: 'wxf44ad38b3e6aa31f', // 必填，公众号的唯一标识
    //   timestamp: currentTime, // 必填，生成签名的时间戳
    //   nonceStr: '', // 必填，生成签名的随机串
    //   signature: '',// 必填，签名
    //   jsApiList: [] // 必填，需要使用的JS接口列表
    // });

  },
  computed: {
    name() {
      return this.$store.state.nickname;
      // return "der der";
    },
    isPreviewMode() {
      return localStorage.getItem('isPreviewMode') === 'true';
    },
  },
  watch: {},
};
</script>

<style lang='scss' scoped>
.box {
  background-color: #f8f8f8;

  .img-tx {
    width: 4rem;
    height: 4rem;
    margin-left: 1rem;
    border-radius: 100%;
    border: 2px solid #fff;
    background-size: contain;
    background: url("../../assets/images/header2.png");
    background-size: 100% 100%;
  }

  height: 100%;

  .banner {
    width: 100%;

    height: 10rem;
    display: flex;
    justify-content: space-between;
  }

  .topview {
    width: 100%;
    // background-image: url("../../assets/images/personal_bg.png");
    // background-image: url("../../assets/images/myPage/topBG.png");
    background-image: url("../../assets/images/my_back.jpg");
    background-size: 101% 100%;
    height: 52vw;
    display: flex;
    justify-content: space-between;
  }

  .empt {
    transform: translateY(35%);
  }

  .icon1 {
    font-size: 25px;
    margin-right: 5px;
  }

  .img {
    width: 20%;
  }

  .icon2 {
    font-size: 20px;
    color: rgb(105, 102, 102) !important;
  }

  .bottom-img {
    width: 4rem;
    height: 4rem;
    margin-left: 1rem;
    border-radius: 100%;
    border: 10px solid #fff;
    background: url("../../assets/images/header.png");
    background-size: contain;
    background-size: 100% 100%;
  }
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem;
  font-size: 1rem;
}

</style>